var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"container"},[(_vm.showBack)?_c('Button',{staticClass:"back",attrs:{"icon":_vm.BackIcon},on:{"click":_vm.onBack}}):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.$i18n.choice(_vm.store.name)))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }